var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-5 text-center text-muted"},[_c('i',{staticClass:"fas fa-search h1"}),_c('br'),_vm._v(" "),_c('div',{staticClass:"py-md-4"},[_vm._v("\n        "+_vm._s(_vm.msg)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }